<template>
    <VueDatePicker v-model="custom"
        :model-value="this.value"
        :flow="this.configDates.calendarFlow"
        :format="'yyyy-MM-dd'"
        :min-date="this.configDates.minDate"
        :max-date="this.configDates.maxDate"
        :year-range="this.configDates.yearRange"
        :start-date="this.configDates.startDate"
        prevent-min-max-navigation
        :enable-time-picker="false"
        :placeholder="this.placeHolderText"
        :hide-navigation="['year','month']"
        auto-apply
        six-weeks
        :offset="60"
        :locale="!!this.lang && this.lang == 'fr' ? 'fr-CA' : 'en-CA'"
        utc="preserve"
        @update:model-value="handleBlur"
    ></VueDatePicker>
    <!-- hide-offset-dates -->
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {inject} from "vue";

export default {
    name: "DatePicker",
    emits: ["update:model-value", "input", "blurFromDate"],
    props: ["minlength","maxlength","type","placeholder","value","name","label","lang"],
    components: {
        VueDatePicker
    },
    setup(props) {
        const { getTranslatedText } = inject('app'); // app is being provided in Application.vue
        return {
            getTranslatedText
        }
    },
    data: () => {

        const todayDate = new Date();
        let todayYear = todayDate.getUTCFullYear();
        let todayDay = todayDate.getUTCDate();
        let todayMonth = todayDate.getUTCMonth() + 1;

        const tomorrowDate = new Date();
        tomorrowDate.setDate(todayDate.getDate() + 2);

        let tomorrowYear = tomorrowDate.getUTCFullYear();
        let tomorrowDay = tomorrowDate.getUTCDate();
        let tomorrowMonth = tomorrowDate.getUTCMonth() + 1;

        todayDay = todayDay.toString().length < 2 ? `0${todayDay}` : todayDay;
        todayMonth = todayMonth.toString().length < 2 ? `0${todayMonth}` : todayMonth;

        tomorrowDay = tomorrowDay.toString().length < 2 ? `0${tomorrowDay}` : tomorrowDay;
        tomorrowMonth = tomorrowMonth.toString().length < 2 ? `0${tomorrowMonth}` : tomorrowMonth;

        // DOB
        const maxAge = 90;
        const minAge = 18;
        const averageAge = 40;

        let configDatesHelper = {
            dob: {
                minDate:`${parseInt(todayYear-maxAge)}-01-01`,
                maxDate:`${parseInt(todayYear-minAge)}-${todayMonth}-${todayDay}`,
                yearRange:[parseInt(todayYear-maxAge), parseInt(todayYear-minAge)],
                startDate:`${parseInt(todayYear-averageAge)}-06-01`,
                calendarFlow:['year','month','calendar']
            },
            payday: {
                minDate:`${tomorrowYear}-${tomorrowMonth}-${tomorrowDay}`,
                maxDate:`${parseInt(tomorrowYear+1)}-${tomorrowMonth}-${tomorrowDay}`,
                yearRange:[tomorrowYear, parseInt(tomorrowYear+1)],
                startDate: `${tomorrowYear}-${tomorrowMonth}-${tomorrowDay}`,
                calendarFlow:['calendar']
            },
        };
        return {
            configDatesHelper
        };
    },
    computed: {
        placeHolderText() {
            let placeholderText = !!this.placeholder && this.placeholder.length > 0 ? this.placeholder : '__select_date__';
            return this.getTranslatedText(placeholderText, 'fields.placeholders');
        },
        custom: {
            get(){ return this.getFormattedDate },
            set(datepickerValue){ this.$emit('input', this.setFormattedDate(datepickerValue)) },
        },
        configDates() {
            const fieldName = `${this.name}`;
            switch(fieldName) {
                case 'pay_date1':
                case 'pay_date2':
                    return this.configDatesHelper.payday;
                    break;
                case 'dob':
                default:
                    return this.configDatesHelper.dob;
                    break;
            }
        },
        getFormattedDate: function() {
            let strDate = this.value;

            if(!strDate || strDate.length!=10) {
                return null;
            }

            let [year, month, day] = strDate.split('-');
            let dateObject = new Date(+year, month - 1, +day).toISOString() ?? null;

            return dateObject ? dateObject.substring(0, 10) : null;
        }
    },
    methods: {
        setFormattedDate: function(rawDate) {

            if(!rawDate) {
                return null;
            }

            let d = new Date(rawDate);
            let month = '' + (d.getUTCMonth() + 1);
            let day = '' + d.getUTCDate();
            let year = d.getUTCFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            let finalDate = [year, month, day].join('-');
            return (!!finalDate && finalDate.length==10) ? finalDate : null;
        },
        handleBlur: function(modelData) {
            this.$emit('blurFromDate', this.setFormattedDate(modelData));
        }
    }
}
</script>
